export default __webpack_public_path__ + "static/media/stacks.e72fb554.svg";